import { QuizTimerStatus } from "../hooks/useQuizTimer";
import TimeRemainingIcon from "../../../../images/time-remainning-icon.svg?react";
import styles from "./CountdownTimer.module.css";
import { Typography } from "@mui/material";
import { useIsInstructor } from "../../../shared";

type CountdownTimerProps = {
	endMs?: number;
} & Pick<QuizTimerStatus, "timerParts">;

export default function CountdownTimer({ timerParts, endMs }: CountdownTimerProps) {
	const isInstructor = useIsInstructor();
	if (!endMs || endMs <= 0 || isInstructor || !timerParts) return null; // Instructor can take assessment for as long as they want
	return (
		<div className={styles.timer}>
			<TimeRemainingIcon />
			<Typography component="span" className={styles.timerPrefix}>
				{timerParts.prefix}
			</Typography>
			<Typography component="span" className={styles.timerCount}>
				{timerParts.count}
			</Typography>
			<Typography component="span" className={styles.timerUnit}>
				{timerParts.unit}
			</Typography>
		</div>
	);
}
